import { TelemetryLapData } from '../../models/TelemetryData';

/** Frame time (ms) at the frame whose distance key is closest to `distance` (metres). */
export function findClosestTimeForDistance(telemetry: TelemetryLapData, distance: number): number {
  const frames = telemetry.t;
  let closestKey: string | null = null;
  let closestDiff = Infinity;
  for (const key of Object.keys(frames)) {
    const diff = Math.abs(parseFloat(key) - distance);
    if (diff < closestDiff) {
      closestDiff = diff;
      closestKey = key;
    }
  }
  return closestKey === null ? 0 : frames[closestKey].m;
}

/** Distance (metres) at the frame whose recorded time `m` is closest to `timeMs`. */
export function findClosestDistanceForTime(telemetry: TelemetryLapData, timeMs: number): number {
  const frames = telemetry.t;
  let closestDist = 0;
  let closestDiff = Infinity;
  for (const key of Object.keys(frames)) {
    const diff = Math.abs(frames[key].m - timeMs);
    if (diff < closestDiff) {
      closestDiff = diff;
      closestDist = parseFloat(key);
    }
  }
  return closestDist;
}

/**
 * Map a chart zoom range (distance, metres) onto the baseline lap's frame times (ms).
 * Returns the full lap [0, maxTime] when there is no zoom or no telemetry.
 */
export function computeWindowTimes(
  telemetry: TelemetryLapData | undefined,
  zoomRange: { min: number; max: number } | null,
  maxTime: number
): { start: number; end: number } {
  if (!telemetry || !zoomRange) return { start: 0, end: maxTime };
  const a = findClosestTimeForDistance(telemetry, zoomRange.min);
  const b = findClosestTimeForDistance(telemetry, zoomRange.max);
  return { start: Math.min(a, b), end: Math.max(a, b) };
}
